import { Component, OnInit, OnDestroy } from '@angular/core';
import {Http, Headers, RequestOptions,Response} from '@angular/http';
import {ShareService } from './../services/services';
import {Welcome,WelcomeService } from './welcome.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { Title } from '@angular/platform-browser';

interface PageData {
  title: string;
  description: string;
  meta_title: string;
  meta_description: string;
  
  
}

@Component({  
    selector: 'welcome-component',  
	//template: require('./welcome.component.html')
	templateUrl: './pg/welcome/welcome.component.html'	
	
})

export class WelcomeComponent implements OnInit {
	
	
	pagedata: PageData;
	public serviceData;
	private _sub: Subscription;
	public metatitle;
    public metadescription;
	constructor(
	    private http: Http,
	    private _route: ActivatedRoute,
	    private _router: Router,
	    private shareService: ShareService,
	    private _title: Title,
	    private _pageService: WelcomeService) {
		   
		   this.pagedata = {
                  title:'',                  
                  description: '',
                  meta_title: '',
                  meta_description: ''
                 
				  	}
				  	
		  
	    }
	    

	ngOnInit() {
	    // this.pagedata.description="umesh naga";
	    //  this.pagedata.slug="umesh hhhnaga";
	   // alert("page");
	   
	  this._sub = this._route.params.subscribe(params => {
			let slug ='Welcome';
			
			 //  console.log(slug);
			   //this._applicationService.doLogin().subscribe	      
			   //this._pageService.getPage(slug);				   
			   
			   this._pageService.getPage(slug).subscribe(
        data => {
                 // 
                                   
                  this.pagedata.title=data.welcome.title;
                  this.pagedata.description=data.welcome.description;
                  //this.metatitle=;
                
                 
                  //$window.document.title ='someTitleYouCreated' ;
                  //console.log(this.pagedata.title);                               
              
           
        },
        err => console.error(err),
        () => console.log('Welcome services completed')
    );
			   
			   
			   
			   
			   
			   		   
		});
		
	
		
	}

    ngOnDestroy() {
       this._sub.unsubscribe();
    }

}



// WEBPACK FOOTER //
// ./resources/assets/typescript/welcome/welcome.component.ts